"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _react = require("@emotion/react");

var css = _interopRequireWildcard(require("./AppBar.styles"));

var _svg = require("./svg");

var _legacy = require("./svg/legacy");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var renderLogo = function renderLogo(variant) {
  var isLegacy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isLegacy) {
    switch (variant.toLowerCase()) {
      case 'zip':
        return (0, _jsxRuntime.jsx)(_legacy.PrimaryZip, {
          css: css.logo
        });

      case 'zipmoney':
        return (0, _jsxRuntime.jsx)(_legacy.PrimaryMoney, {
          css: css.logo
        });

      case 'zippay':
        return (0, _jsxRuntime.jsx)(_legacy.PrimaryPay, {
          css: css.logo
        });

      case 'ziptrade':
        return (0, _jsxRuntime.jsx)(_legacy.PrimaryTrade, {
          css: css.logo
        });

      default:
        return (0, _jsxRuntime.jsx)(_legacy.PrimaryZip, {
          css: css.logo
        });
    }
  } else {
    switch (variant.toLowerCase()) {
      case 'zip':
        return (0, _jsxRuntime.jsx)(_svg.PrimaryZip, {
          css: css.logo
        });

      case 'zipmoney':
        return (0, _jsxRuntime.jsx)(_svg.PrimaryMoney, {
          css: css.logo
        });

      case 'zippay':
        return (0, _jsxRuntime.jsx)(_svg.PrimaryPay, {
          css: css.logo
        });

      case 'ziptrade':
        return (0, _jsxRuntime.jsx)(_svg.PrimaryTrade, {
          css: css.logo
        });

      case 'ziptradeplus':
        return (0, _jsxRuntime.jsx)(_svg.PrimaryTradePlus, {
          css: css.logo
        });

      default:
        return (0, _jsxRuntime.jsx)(_svg.PrimaryZip, {
          css: css.logo
        });
    }
  }
};

var AppBar = function AppBar(_ref) {
  var endAdornment = _ref.endAdornment,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'static' : _ref$position,
      startAdornment = _ref.startAdornment,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'zip' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["endAdornment", "position", "startAdornment", "variant"]);

  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsx)(_AppBar["default"], _objectSpread(_objectSpread({
    color: "secondary",
    css: css.appbar,
    position: position
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)(_Toolbar["default"], {
      children: (0, _jsxRuntime.jsxs)(_Grid["default"], {
        container: true,
        justifyContent: "space-between",
        children: [(0, _jsxRuntime.jsx)(_Grid["default"], {
          item: true,
          xs: true,
          children: (0, _jsxRuntime.jsx)("div", {
            css: css.item,
            children: startAdornment
          })
        }), (0, _jsxRuntime.jsx)(_Grid["default"], {
          item: true,
          container: true,
          alignItems: "center",
          xs: 8,
          children: renderLogo(variant, theme.name === 'legacy')
        }), (0, _jsxRuntime.jsx)(_Grid["default"], {
          item: true,
          xs: true,
          children: (0, _jsxRuntime.jsx)("div", {
            css: css.item,
            children: endAdornment
          })
        })]
      })
    })
  }));
};

var _default = AppBar;
exports["default"] = _default;